import { Input } from '@/components/ui/input';
import { cn } from '@/lib/utils';

/**
 * A percentage field with the `%` suffix inside it.
 *
 * Held as raw text rather than a number input: percentages are typed in states
 * that aren't yet numbers ("-", "3."), and the form validates on save instead of
 * fighting the keystroke.
 */
export function PercentInput({
  id,
  ariaLabel,
  value,
  invalid,
  disabled,
  className,
  showSuffix = true,
  acceptsText = false,
  onChange,
}: {
  id?: string;
  /** For fields with no visible <Label> of their own, such as table cells. */
  ariaLabel?: string;
  value: string;
  invalid: boolean;
  disabled: boolean;
  className?: string;
  /** Off for a value that isn't a number, such as "N/A". */
  showSuffix?: boolean;
  /**
   * Set where a word is a valid value ("N/A"), so a phone shows a keyboard
   * with letters rather than the numeric one.
   */
  acceptsText?: boolean;
  onChange: (value: string) => void;
}) {
  return (
    <div className={cn('relative', className)}>
      <Input
        id={id}
        aria-label={ariaLabel}
        value={value}
        inputMode={acceptsText ? 'text' : 'decimal'}
        disabled={disabled}
        className={cn('h-8 pr-6 text-sm', invalid && 'border-destructive')}
        onChange={(event) => onChange(event.target.value)}
      />
      {showSuffix && (
        <span className="pointer-events-none absolute inset-y-0 right-2 flex items-center text-xs text-muted-foreground">
          %
        </span>
      )}
    </div>
  );
}
